import { combineReducers } from 'redux';

import { mainReducer } from './main/main.reducer';
import { clientReducer } from './client/client.reducer';
import { quizReducer } from './quiz/quiz.reducer';
import { historyReducer } from './history/history.reducer';
import { ecommerceReducer } from './ecommerce/ecommerce.reducer';
import { phoneFormReducer } from './phone-form/phone-form.reducer';
import { dateFormReducer } from './date-form/date-form.reducer';

const rootReducer = combineReducers({
	main: mainReducer,
	client: clientReducer,
	phoneForm: phoneFormReducer,
  dateForm: dateFormReducer,
	quiz: quizReducer,
	history: historyReducer,
  ecommerce: ecommerceReducer
});

export default rootReducer;